<template>
  <div>
    <div>
      <el-input v-model="msg" :rows="4" type="textarea" placeholder="请输入不通过原因"/>
      <el-checkbox-group v-model="msgA" @change="msgChange"  style="margin: 20px 0;">
        <p v-for="item in msgArray" :key="item.id">
          <el-checkbox :label="item.label" :value="item"></el-checkbox>
        </p>
      </el-checkbox-group>
    </div>
    <div class="dialog-footer" style="text-align: left">
      <el-button size="medium" @click="cancel">返 回</el-button>
      <el-button type="primary"  @click="reject" v-loading="rejectLoading">发送 & 不通过</el-button>
    </div>
  </div>
</template>

<script>
import {postFormData} from "@/api/api";
import {batchUpdateWeChatState} from "@/api/url"

export default {
  name: "VideoPlay",
  props: {
    value: Object
  },
  data() {
    return {
      ids: this.value.ids,
      msg: '',
      msgArray: [{
        label: '非微信二维码图片',
        value: '非微信二维码图片',
        checked: false
      },
        {
          label: '您的微信二维码图片不清晰',
          value: '您的微信二维码图片不清晰',
          checked: false
        },
        {
          label: '微信未开启添加好友功能',
          value: '微信未开启添加好友功能',
          checked: false
        },
        {
          label: '微信账号异常，无法被添加',
          value: '微信账号异常，无法被添加',
          checked: false
        }
      ],
      //消息前缀
      msgPrefix: '您的微信二维码未能通过审核，具体原因为：',//不通过的原因
      msgA: [],
      rejectLoading: false,

    }
  },
  methods: {

    //原因更改事件
    msgChange() {
      this.msg = this.msgPrefix;
      this.msgA.forEach(e => {
        this.msg += e;
        this.msg += '；'
      });
      if(this.msgA.length){
        this.msg = this.msg.substring(0, this.msg.length - 1);
        this.msg += '。'
      }
    },

    //返回
    cancel() {
      // this.carForm = this.value.carForm,
      this.$emit('close');
    },

    //提交
    reject() {
      if(!this.msg){
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请输入不通过原因',
          type: 'warning'
        })
        return false
      }
      this.$confirm('确认不通过选中的用户并发送原因？').then(() => {
        this.rejectLoading = true;
        let _this = this;
        let param = {};
        param['idArr'] = this.ids;
        param['state'] = 3;
        param['imMsg'] = this.msg;
        postFormData(batchUpdateWeChatState,param).then(function(data){
          let {code,msg} = data;
          if(code == 200){
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            _this.$emit('confirm')
          }else{
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          _this.rejectLoading = false;
        })
            .catch(function(response){
              _this.rejectLoading = false;
            })
      })
          .catch(() => {})
    }

  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
